export const FREQUENCY = {
  WEEK_ID: 1,
  BIWEEK_ID: 2,
  MONTH_ID: 3,
  DAY_ID: 4,
  MINUTE_ID: 5,
  HOUR_ID: 6,
  SEMESTER_ID: 7,
  BIMESTRE_ID: 8,
  QUARTER_ID: 9
};

export const FREQUENCY_DAYS = {
  WEEK: 7,
  BI_WEEK: 15,
  MONTH: 30
};

// REFACTOR eliminar e utilizar essas constantes: src/app/config/prescription_shifts.js
export const FREQUENCY_PER_SHIFT = {
  MORNING: 1,
  AFTERNOON: 2,
  NIGHT: 3
};

export const FREQUENCY_SCHEDULE = {
  SPECIFIC_TIME: 1,
  PER_SHIFT: 2
};

export const FREQUENCY_TYPE_NAME = {
  [FREQUENCY.WEEK_ID]: 'Semana(s)',
  [FREQUENCY.BIWEEK_ID]: 'Quinzena(s)',
  [FREQUENCY.MONTH_ID]: 'Mês(es)',
  [FREQUENCY.DAY_ID]: 'Dia(s)',
  [FREQUENCY.HOUR_ID]: 'Hora(s)',
  [FREQUENCY.MINUTE_ID]: 'Minuto(s)',
  [FREQUENCY.SEMESTER_ID]: 'Semestre(s)',
  [FREQUENCY.BIMESTRE_ID]: 'Bimestre(s)',
  [FREQUENCY.QUARTER_ID]: 'Trimestre(s)'
};
